import * as Yup from 'yup';

export const schema = Yup.object().shape({
	authorizationCode: Yup.string().required('required'),
});
